import axios from './_nestAxios'

// Get

export const obtenerxIdAsEdicion = id => axios.get(`/pre-facturaciones/${id}`)

export const obtenerxEstadoAsTabla = estado =>
  axios.get('/pre-facturaciones', {
    params: {
      tipoConsulta: 'x-estado',
      estado: estado
    }
  })

export const obtenerxIdAsDetallesVenta = id =>
  axios.get(`/pre-facturaciones/${id}`, {
    params: {
      tipoConsulta: 'detalles-as-ventas'
    }
  })

// Post

export const nuevo = data => axios.post('/pre-facturaciones', data)

// Put

export const actualizarxId = (id, data) => axios.put(`/pre-facturaciones/${id}`, data)

// Delete

export const eliminarxId = id => axios.delete(`/pre-facturaciones/${id}`)
